export default {
    fetchError: 'Failed to load borrowing data',
    loading: 'Loading borrowing...',
    errorTitle: 'Error',
    notFound: 'Borrowing not found',
    reservation: 'Reservation',
    borrowing: 'Borrowing',
    borrowingDetails: 'Borrowing Details',
    reservationDetails: 'Reservation Details',
    borrower: 'Borrower',
    reservedFrom: 'Reserved From',
    reservedUntil: 'Reserved Until',
    reservedFromTo: 'Reservation Period',
    reservationDate: 'Reservation Date',
    reservationDuration: 'Reservation Duration',
    borrowedAt: 'Borrowed At',
    expectedReturnAt: 'Expected Return',
    returnedAt: 'Returned At',
    duration: 'Borrowing Duration',
    createdAt: 'Created At',
    updatedAt: 'Last Updated',
    since: 'Since',
    notes: 'Notes',
    borrowingNotes: 'Borrowing Notes',
    reservationNotes: 'Reservation Notes',
    returnNotes: 'Return Notes',
    returnResource: 'Return Resource',
    startReservation: 'Start Reservation and Borrow',
    editReservation: 'Edit Reservation',
    deleteReservation: 'Delete Reservation',
    borrowResource: 'Borrow Resource',
    viewResource: 'View Resource',
    noImage: 'No Image',
    timelineTitle: 'Timeline',
    timeline: {
        reserved: 'Resource Reserved',
        borrowed: 'Resource Borrowed',
        expectedReturn: 'Expected Return',
        returned: 'Resource Returned',
        overdue: 'Overdue',
        by: 'by'
    },
    status: {
        reserved: 'Reserved',
        reservationActive: 'Reservation Active',
        reservationExpired: 'Reservation Expired',
        borrowedActive: 'Borrowed',
        overdue: 'Overdue',
        returned: 'Returned',
        pendingValidation: 'Pending Validation',
        validationRejected: 'Validation Rejected',
        available: 'Available',
        unavailable: 'Unavailable'
    },
    durationData: {
        oneDay: '1 day',
        days: '{{count}} days',
        oneWeek: '1 week',
        weeks: '{{count}} weeks',
        oneMonth: '1 month',
        months: '{{count}} months',
        weeksAndDays: '{{weeks}} weeks and {{days}} days'
    }
};
